import React from 'react';

export default function About() {
  return (
    <section className='about-section'>
      <h1>Why to use a password generator?</h1>

      <p>
      It is important to keep your online activity and work secured nowadays, as potential hackers can come with different tools and strategies to penetrate your online accounts, and steal any data they find, thus creating damage to your digital assets in unknown ways.
      <br/><br/><br/>Random and unique passwords are one way to prevent this, significantly reducing the risk of a breach on your accounts, and that way keeping you online activity safe.
      </p>

      
    </section>
  )
}
